import { render, staticRenderFns } from "./disease_research.vue?vue&type=template&id=44c8e12b&scoped=true"
import script from "./disease_research.vue?vue&type=script&lang=js"
export * from "./disease_research.vue?vue&type=script&lang=js"
import style0 from "./disease_research.vue?vue&type=style&index=0&id=44c8e12b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c8e12b",
  null
  
)

export default component.exports